function isIOS () {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}

function main () {
  if (isIOS()) {
    document.body.classList.add('is-ios')
  }
}

main()
